import { PlatformDefaultsSource } from "../@types"

export interface PlatformDefaults {
  hdxEnabled: boolean
}

export const createPlatformDefaultsConfig: (
  source: PlatformDefaultsSource,
) => PlatformDefaults = (s) => new PlatformDefaultsImpl(s)

class PlatformDefaultsImpl implements PlatformDefaults {
  private _hdxEnabled: boolean
  constructor(source: PlatformDefaultsSource) {
    // Sensible defaults
    this._hdxEnabled = true
    /* eslint-disable @typescript-eslint/dot-notation */
    const hdx = source["hdx"]
    if (typeof hdx === "boolean") {
      this._hdxEnabled = hdx
    }
    /* eslint-enable @typescript-eslint/dot-notation */
  }

  get hdxEnabled() {
    return this._hdxEnabled
  }
}
